import Component from './Component';
import * as idb from './modules/dashboard';
import * as statistics from './modules/statistics';

export { idb, statistics };
export default Component;
